import { Injectable, signal } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({ providedIn: 'root' })
export class AgenticAuthTokenService {
  private readonly currentToken = signal('');
  readonly token = this.currentToken.asReadonly();

  constructor(private readonly oauthService: OAuthService) {
    this.refresh();
    this.oauthService.events.subscribe(() => this.refresh());
  }

  private refresh(): void {
    this.currentToken.set(this.oauthService.getIdToken() ?? '');
  }
}
